<template>
  <div>
    <div class="carousel-box" style="width: 100%; display: inline-block;">
      <div
        class="bg-white row no-gutters box-3 align-items-center border border-light rounded hov-shadow-md my-2 has-transition"
      >
        <div class="col-4">
          <router-link :to="shopUrl" class="d-block p-3" tabindex="0">
            <div
              style="width: 110px; height: 110px; display: flex; align-items: center; justify-content: center"
            >
              <img
                :src="getFileViewUrl(item.imgHead)"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </router-link>
        </div>
        <div class="col-8 border-left border-light">
          <div class="p-3 text-left">
            <h2 class="h6 fw-600 text-truncate">
              <router-link :to="shopUrl" class="text-reset" tabindex="0"
                >{{ item.name }}
              </router-link>
            </h2>
            <StarsComp :star="item.stars" />
            <router-link
              :to="shopUrl"
              class="btn btn-soft-primary btn-sm"
              tabindex="0"
            >
              {{ $t("访问商店") }}
              <i class="las la-angle-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StarsComp from "@/components/StarsComp.vue";

export default {
  components: {
    StarsComp
  },
  props: {
    item: Object
  },
  computed: {
    shopUrl() {
      return `/shop?shopId=${this.item.id}`;
    }
  }
};
</script>
